import { produce } from "immer"
import { SNACKBAR_CLEAR, SNACKBAR_ENQUEUE } from "./snackbar.actions"
import type { ISnackbarState, SnackbarAction, SnackbarMessage } from "./snackbar.types"

const snackbarInitialState: ISnackbarState = {
  queue: undefined
}

export function snackbarReducer(currentState: ISnackbarState | undefined, action: SnackbarAction): ISnackbarState {
  const state = currentState ?? snackbarInitialState
  switch (action.type) {
    case SNACKBAR_ENQUEUE: {
      return setQueue(state, action.payload as SnackbarMessage)
    }
    case SNACKBAR_CLEAR: {
      return clearQueue(state)
    }
    default: {
      return state
    }
  }
}

function setQueue(currentState: ISnackbarState, notification: SnackbarMessage): ISnackbarState {
  return produce(currentState, (draftState: ISnackbarState) => {
    draftState.queue = notification
  })
}

function clearQueue(currentState: ISnackbarState): ISnackbarState {
  return produce(currentState, (draftState: ISnackbarState) => {
    draftState.queue = undefined
  })
}
